export const sourceStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  UNKNOWN_FEED: 'unknown_feed',
  INVALID_FEED: 'invalid_feed',
  ERROR: 'error',
  PENDING_ENRICHMENT: 'pending-enrichment',
};

export const sourceLanguages = {
  ENGLISH: 'en',
  DUTCH: 'nl',
  SPANISH: 'es',
  FRENCH: 'fr',
};

export const sourceTypes = {
  RSS: 'rss',
  TWITTER: 'twitter',
  HTML_LINKS: 'html-links',
};
